import { render, staticRenderFns } from "./ColaboradoresTable.vue?vue&type=template&id=1edc6ed6&"
import script from "./ColaboradoresTable.vue?vue&type=script&lang=js&"
export * from "./ColaboradoresTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports